import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "footer",
  class: "noselect"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-8 align-middle" }
const _hoisted_4 = { class: "ms-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-graduation-cap p-color-1" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Quicksource Guide ")
const _hoisted_9 = { class: "fw-bold text-tiny" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { id: "qsChat" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: "hover",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openGuide(this.guideIsVisible)))
            }, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("span", {
                class: "guide-toggle-label",
                innerHTML: this.guideIsVisible ? 'Hide' : 'Show'
              }, null, 8, _hoisted_7),
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, "(" + _toDisplayString(this.guideStepsCompleted) + " of " + _toDisplayString(this.guideStepsTotal) + " Complete)", 1)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["col-4 text-end", [_ctx.chatEnabled(_ctx.isChatEnabled)]])
        }, [
          _createElementVNode("button", {
            type: "button",
            id: "save-report",
            class: "btn btn-primary me-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveAndClose()))
          }, "Save & Close"),
          _createElementVNode("button", {
            type: "button",
            id: "cancel-report",
            class: "btn btn-outline-secondary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeApp()))
          }, "Cancel"),
          _hoisted_10
        ], 2)
      ])
    ]),
    (_ctx.modalConfirmation.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalConfirmation.component), {
          key: 0,
          message: _ctx.modalConfirmation.message,
          buttons: _ctx.modalConfirmation.buttons,
          onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalConfirmation.show = false))
        }, null, 8, ["message", "buttons"]))
      : _createCommentVNode("", true)
  ], 64))
}